import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { useAuthContext } from '@myphx-engineering/auth/client';
import {
    Flex,
    HorizontalDivider,
    IconMedication,
    SideNavLink,
    SidebarHeading,
    Stack,
} from '@myphx-engineering/phx-design-system';

import { getAbsoluteRoute } from '../../../util/get-absolute-route';
import { ConditionalComponent } from '../../utility/ConditionalComponent';

export const MyAccountSection = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { isAuthenticated } = useAuthContext();

    const navigateToCabinetRoot = useCallback(() => {
        navigate(getAbsoluteRoute('cabinet.root'));
    }, [navigate]);

    return (
        <ConditionalComponent condition={isAuthenticated}>
            <Stack gap="sm">
                <HorizontalDivider variant="middle" />
                <Stack gap={0}>
                    <Flex px="md" pb="xxs">
                        <SidebarHeading>
                            {t('sidebar.myAccount.heading')}
                        </SidebarHeading>
                    </Flex>
                    <SideNavLink
                        label={t('sidebar.myAccount.medCab')}
                        Icon={IconMedication}
                        onClick={navigateToCabinetRoot}
                    />
                </Stack>
            </Stack>
        </ConditionalComponent>
    );
};
